import React from 'react';
import map from 'lodash/map';

import { VisuallyHiddenP } from 'zoomforth_codesbane_viewer/component_lib/visually_hidden.jsx';

import SiteViewerVersionComponentSelector
  from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';

const SubmenuNavigationUi_ViewerVersion1 = ({
  SubmenuItemComponent,
  menuItems,
  currentSubpage,
  lastClickedSubmenuItemId
})=> (
  <div className="submenu-links-container">
    {
      map(menuItems, submenuItem =>
        <SubmenuItemComponent
          key={submenuItem.id}
          submenuItem={submenuItem}
          currentSubpage={currentSubpage}
          lastClickedSubmenuItemId={lastClickedSubmenuItemId}
        />
      )
    }
  </div>
);

const SubmenuNavigationUi_ViewerVersion2 = ({
  SubmenuItemComponent,
  menuItems,
  currentSubpage,
  lastClickedSubmenuItemId
})=> (
  <nav
    aria-labelledby="pageNavLabel"
    className="submenu-links-container"
  >
    <VisuallyHiddenP id="pageNavLabel">
      Page
    </VisuallyHiddenP>

    <ul role="list" className="nav-links-list">
      {
        map(menuItems, (submenuItem)=> (
          <SubmenuItemComponent
            key={submenuItem.id}
            submenuItem={submenuItem}
            currentSubpage={currentSubpage}
            lastClickedSubmenuItemId={lastClickedSubmenuItemId}
          />
        ))
      }
    </ul>
  </nav>
);

const SubmenuNavigationUi = (props)=> (
  <SiteViewerVersionComponentSelector>
    <SubmenuNavigationUi_ViewerVersion1 forSiteViewerVersion={1} { ...props } />
    <SubmenuNavigationUi_ViewerVersion2 forSiteViewerVersion={2} { ...props } />
  </SiteViewerVersionComponentSelector>
);

export default SubmenuNavigationUi;
